import {
  foundationColorTokens,
  foundationMotionTokens,
  foundationRadiusTokens,
  foundationSemantic,
  foundationShadowTokens,
  foundationThemes
} from '../foundation';

// Compatibility adapter for legacy app components that still consume THEME_CLASSES directly.
export const THEME_COLORS = {
  light: {
    background: foundationThemes.light.backgroundHex
  },
  dark: {
    background: foundationThemes.dark.backgroundHex
  }
} as const;

// Tailwind classes
export const THEME_CLASSES = {
  background: foundationColorTokens.background.canvas,
  border: foundationColorTokens.border.subtle,
  text: {
    primary: foundationSemantic.text.primary,
    secondary: foundationSemantic.text.secondary,
  },
  hover: {
    background: foundationSemantic.interactive.hoverSurface,
    text: foundationSemantic.interactive.hoverText,
  },
  input: {
    background: foundationSemantic.input.surface,
    border: foundationSemantic.input.border,
    text: foundationSemantic.input.text,
    placeholder: foundationSemantic.input.placeholder,
    base: foundationSemantic.input.base,
    field: foundationSemantic.input.field,
    textarea: foundationSemantic.input.textarea
  },
  button: {
    primary: foundationSemantic.action.primary,
    secondary: foundationSemantic.action.secondary,
    danger: foundationSemantic.action.danger,
    hover: foundationSemantic.interactive.hoverSurface,
    icon: `p-1 ${foundationSemantic.interactive.hoverSurface} ${foundationRadiusTokens.full} ${foundationMotionTokens.colors}`,
    iconSmall: `p-1 ${foundationRadiusTokens.full} ${foundationSemantic.interactive.hoverSurface} ${foundationMotionTokens.colors}`
  },
  status: {
    error: 'bg-red-100 dark:bg-red-950 text-red-700 dark:text-red-300',
    success: `${foundationColorTokens.status.successSurface} ${foundationColorTokens.status.successText}`,
    default: 'bg-slate-200 dark:bg-slate-900',
    done: foundationColorTokens.status.successSurface
  },
  card: {
    background: foundationColorTokens.background.surface,
    border: foundationColorTokens.border.subtle,
    hover: {
      transform: `${foundationMotionTokens.emphasis} ${foundationMotionTokens.lift}`,
      shadow: foundationShadowTokens.cardHover,
      border: 'hover:border-brand/50',
      full: `${foundationMotionTokens.emphasis} ${foundationMotionTokens.lift} ${foundationShadowTokens.cardHover} hover:border-brand/50`
    }
  },
  dropdown: {
    background: foundationColorTokens.background.surface,
    item: {
      base: foundationSemantic.text.secondary,
      hover: foundationSemantic.interactive.hoverSurface
    }
  },
  note: {
    card: {
      background: {
        green: 'bg-green-100 dark:bg-green-950',
        purple: 'bg-purple-100 dark:bg-purple-950',
        blue: 'bg-blue-100 dark:bg-blue-950',
        orange: 'bg-orange-100 dark:bg-orange-950',
        red: 'bg-red-100 dark:bg-red-950',
        gray: 'bg-slate-100 dark:bg-slate-900'
      }
    },
    timeline: {
      dateMark: {
        today: 'bg-red-400 dark:bg-red-900 text-white dark:text-white',
        weekend: 'bg-slate-100 dark:bg-slate-800',
        weekday: 'bg-transparent',
        border: 'border-slate-200 dark:border-slate-700'
      }
    }
  }
} as const;
